module.exports = __webpack_public_path__ + "assets/font/SourceHanSansTWHK-Normal-d0713443.woff2";